import '@/audio/mute';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { unlockAudioOnTaps } from '@/audio/context';
import '@/styles/global.css';

// A deploy replaced the build files this page was loaded with (a lazily loaded chunk is gone):
// reload once to get the current build, instead of failing.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'foe-names.reloaded-for';
  const build = document.querySelector('script[type="module"]')?.getAttribute('src') ?? '';
  try {
    if (sessionStorage.getItem(key) === build) return;
    sessionStorage.setItem(key, build);
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

// Every tap unlocks audio (iOS plays sound only when started from a tap).
unlockAudioOnTaps();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
